<template>
  <div class="py-4 container-fluid">
    <div class="row pb-0 ">
      <div class="col-lg-12">
        <div class="row text-left">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-4">
                <label class="col-form-label font-weight-bold">ACCOUNT LIST</label>
              </div>
              <div class="col-2">
                <button class="btn btn-sm btn-primary"
                        data-toggle="modal"
                        data-target="#adding-account-modal"
                        data-backdrop="static"
                        data-keyboard="false">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row text-left">
          <div class="col-md-4">
            <div class="input-group-prepend">
              <div class="input-group-prepend">
                <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                  <font-awesome-icon icon="search"/>
                  By : {{ keyDisplay }}
                </button>

                <div class="dropdown-menu">
                  <a class="dropdown-item" :class="{'active':key == 'all'}" @click="setKey('all')">All</a>
                  <a class="dropdown-item" :class="{'active':key == 'name'}" @click="setKey('name')">Firstname</a>
                  <a class="dropdown-item" :class="{'active':key == 'middle_name'}" @click="setKey('middle_name')">Middlename</a>
                  <a class="dropdown-item" :class="{'active':key == 'last_name'}"
                     @click="setKey('last_name')">Lastname</a>
                  <a class="dropdown-item" :class="{'active':key == 'username'}"
                     @click="setKey('username')">Username</a>
                </div>
              </div>
              <input type="text"
                     class="form-control form-control-sm"
                     style="margin-right: 12px"
                     aria-label="Text input with dropdown button"
                     v-model="searchValue"
                     v-on:input="debounceRendering"
                     :placeholder="keyPlaceHolder">
            </div>
          </div>
        </div>
        <div class="row text-left">
          <div class="col-lg-6">
            <nav aria-label="..." class="pt-0">
              <ul class="pagination pagination-sm">
                <li class="page-item" :class="{ 'disabled': userAccountPagination.currentPage === 1}">
                  <button class="page-link" @click="setPage(1)">
                    <font-awesome-icon icon="step-backward"/>
                    First
                  </button>
                </li>

                <li v-for="page in paginationPages" :key="page" class="page-item"
                    :class="{ 'disabled': page === '...', 'active': page === userAccountPagination.currentPage }">
                  <button class="page-link" @click="setPage(page)">{{ page }}</button>
                </li>

                <li class="page-item"
                    :class="{ 'disabled': userAccountPagination.currentPage === userAccountPagination.lastPage}">
                  <button class="page-link" @click="setPage(userAccountPagination.lastPage)">
                    Last
                    <font-awesome-icon icon="step-forward"/>
                  </button>
                </li>

              </ul>
            </nav>
            <div class="text-left">
              <small> {{
                  `${userAccountPagination.from} - ${userAccountPagination.to} of ${userAccountPagination.total}`
                }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="table table-responsive-lg">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th class="p-1 text-center align-middle pl-3" style="width: 10% !important;">First Name</th>
              <th class="p-1 text-center align-middle pl-3" style="width: 10% !important;">Middle Name</th>
              <th class="p-1 text-center align-middle pl-3" style="width: 10% !important;">Last Name</th>
              <th class="p-1 text-center align-middle pl-3" style="width: 7% !important;">Username</th>
              <th class="p-1 text-center align-middle pl-3" style="width: 10% !important;">Created At</th>
              <th class="p-1 text-center align-middle pl-3" style="width: 3% !important;">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(account,index) in accounts" :key="account.id">
              <td class="p-0 align-middle text-left pl-3">{{
                  account.firstName ? account.firstName.toUpperCase() : ''
                }}
              </td>
              <td class="p-0 align-middle text-left pl-3">{{
                  account.middleName ? account.middleName.toUpperCase() : ''
                }}
              </td>
              <td class="p-0 align-middle text-left pl-3">{{
                  account.lastName ? account.lastName.toUpperCase() : ''
                }}
              </td>
              <td class="p-0 align-middle text-center pl-3">{{
                  account.username ? account.username.toUpperCase() : ''
                }}
              </td>
              <td class="p-0 align-middle text-center pl-3">{{
                  account.createdAt ? account.createdAt.toUpperCase() : ''
                }}
              </td>
              <td>
                <button class="btn btn-sm btn-warning" @click="viewAccount(account)"
                        data-toggle="modal"
                        data-target="#view-account-modal"
                        data-backdrop="static"
                        data-keyboard="false">
                  <font-awesome-icon icon="edit"/>
                </button>
<!--                <button class="btn btn-sm btn-danger ml-2">
                  <font-awesome-icon icon="trash"/>
                </button>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="adding-account-modal" tabindex="-1" role="dialog"
           aria-labelledby="addAccountModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addAccountModalTitle">New Account</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">First Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.fName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Middle Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.mName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Last Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.lName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">User type</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <select name="userType" id="user-type" class="form-control form-control-sm"
                          v-model="newAccount.userTypeId">
                    <option :value="null" class="text-center align-middle">-- SELECT --</option>
                    <option :value="userType.id" v-for="(userType,index) in objUserTypes" :key="userType.id"
                            class="text-left align-middle">
                      {{ userType.name.toUpperCase() }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Position</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <select name="accountPosition" id="account-position" class="form-control form-control-sm"
                          v-model="newAccount.posId">
                    <option :value="null" class="text-center align-middle">-- SELECT --</option>
                    <option :value="pos.id" v-for="(pos,index) in objPositions" :key="pos.id"
                            class="text-left align-middle">
                      {{ pos.name.toUpperCase() }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Username</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.username">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Password</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <label class="col-form-label">Auto generated</label>
                </div>
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="createAccount">Save</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <!-- View Account modal     -->
      <div class="modal fade" id="view-account-modal" tabindex="-1" role="dialog"
           aria-labelledby="viewAccountModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addAccountModalTitle">Account Details</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">First Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="account.firstName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left">Middle Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="account.middleName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left align-middle">Last Name</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="account.lastName">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left align-middle">User type</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <select name="userType" id="user-type" class="form-control form-control-sm" v-model="account.userTypeId">
                    <option :value="null" class="text-center align-middle">-- SELECT --</option>
                    <option :value="userType.id" v-for="(userType,index) in objUserTypes" :key="userType.id"
                            class="text-left align-middle">{{ userType.name.toUpperCase() }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-lg-4 col-form-label text-left align-middle">Position</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <div class="custom-control custom-checkbox text-left" v-for="(position,index) in objPositions">
                    <input type="checkbox" :value="position.id" class="custom-control-input"
                           @change="remPos($event,position)"
                           :id="`customCheck1`+index"
                           :checked="setPositions(position.id,account.positions)">
                    <label class="custom-control-label text-left pl-1 align-middle "
                           :for="`customCheck1`+index">{{ position.name }}</label>
                  </div>
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-form-label col-lg-4 text-left">Username</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="account.username">
                </div>
              </div>

              <div class="form-group row justify-content-center">
                <label class="col-form-label col-lg-4 text-left">Reset Password</label>
                <span class="col-form-label">:</span>
                <div class="col-md-6">
                  <input type="text" class="form-control form-control-sm" v-model="account.password">
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="updateAccount">Update</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { appMixins } from '@/mixins/app.mixins'
import { alertMixins } from '@/mixins/alertMixins'
import __ from 'lodash'

export default {
  name: 'Account',
  mixins: [appMixins, alertMixins],
  /** data **/
  data () {
    return {
      key: 'all',
      keyPlaceHolder: 'Search here...',
      keyDisplay: 'ALL',
      page: '',
      searchValue: null,
      excluded: []
    }
  },

  /**  computed  **/
  computed: {
    ...mapGetters([
      'accounts',
      'account',
      'newAccount',
      'userAccountPagination',
      'objUserTypes',
      'objPositions'
    ]),

    paginationPages () {
      const pages = []
      const currentPage = this.userAccountPagination.currentPage
      const lastPage = this.userAccountPagination.lastPage
      if (lastPage > 1) {
        let initialLimit = 1
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i)
          if (i >= lastPage) {
            break
          }
        }
      }
      return pages
    }
  },

  /** methods**/
  methods: {
    ...mapActions([
      'create_account',
      'reset_account',
      'update_account',
      'delete_account',
      'set_account',
      'set_accounts',
      'reset_obj_user_types',
      'reset_obj_positions',
      'reset_state_account',
      'reset_obj_account',
      'view_account'
    ]),

    debounceRendering: __.debounce(function () {
      this.searchCrew(1)
    }, 500),

    async createAccount () {
      if (await this.questionAlert('Are you sure you want to save this details.?', 'Create Account')) {
        this.create_account(this.newAccount).then((r) => {
          if (r) {
            this.successAlert('Crew record added successfully', 'Create Record')
            console.log('creating account', r)
          }
        })
      }
    },

    // TODO view
    viewAccount (formObj) {
      console.log('viewAccount:component', formObj)
      // Object.assign(this.account, formObj);
      this.view_account(formObj)
    },

    // TODO
    async updateAccount () {
      if (await this.questionAlert('Do you want to save the changes that you made.', 'Update Account')) {
        console.log('updateAccount:component')

        if (this.excluded.length != 0) {
          this.account.excluded = this.excluded
        }

        this.update_account(this.account).then((r) => {
          this.successAlert('Update details successfully', 'Update Details')
          if (r) {
            this.$nextTick(() => {
              this.successAlert('Update details successfully', 'Update Details')
              // this.debounceRendering();
            })
          }
        })
      } else {
        this.excluded = []
      }
    },

    // TODO delete
    async deleteAccount (accountId) {
      if (await this.questionAlert('Are you sure to delete this account record?', 'Delete Account Record')) {
        this.delete_account(accountId).then((r) => {
          this.$nextTick(() => {
            console.log('This is something i need to learn')
          })
        })
      }
    },

    loadAccountList () {
      const parameters = {
        searchKey: this.key,
        searchValue: this.searchValue,
        page: this.userAccountPagination.currentPage
      }
      this.set_accounts(parameters)
    },

    setPage (page) {
      this.userAccountPagination.currentPage = page
      this.loadAccountList()
    },

    setKey (key) {
      this.key = key
      switch (key) {
        case 'name':
          this.keyDisplay = 'First name'
          this.keyPlaceHolder = 'Search by Firstname'
          break

        case 'middle_name':
          this.keyDisplay = 'Middle name'
          this.keyPlaceHolder = 'Search by Middlename'
          break
        case 'last_name':
          this.keyDisplay = 'Last name'
          this.keyPlaceHolder = 'Search by Lastname'
          break

        case 'username':
          this.keyDisplay = 'Username'
          this.keyPlaceHolder = 'Search by username'
          break

        default:
          this.keyDisplay = 'All'
          this.keyPlaceHolder = 'Search here...'
          break
      }
    },

    searchCrew (initPage = 1) {
      const thisPage = (initPage) || this.userAccountPagination.currentPage
      const params = {
        page: thisPage,
        searchKey: this.key,
        searchValue: this.searchValue
      }
      this.set_accounts(params)
    },

    setPositions (obj, array) {
      console.log('setPositions:component', array)
      if (array == undefined) {
        return
      }
      return array.some((val, index) => {
        return val.id === obj
      })
    },

    addPos (obj) {
      console.log('addPos:component', obj)
      this.account.positions.push(obj)
    },

    remPos (e, obj) {
      const isChecked = e.target.checked

      console.log('remPos:component', obj.id)

      if (isChecked) {
        this.addPos(obj)
        const excludedIndex = this.excluded.findIndex((val, index) => {
          return val === obj.id
        })
        this.excluded.splice(excludedIndex, 1)
      } else {
        const indexPos = this.account.positions.findIndex((val, index) => {
          return val.id === obj.id
        })
        this.account.positions.splice(indexPos, 1)
        this.excluded.push(obj.id)
      }

      console.log('excluded:', this.excluded)
    }
  },

  /** mounted **/
  mounted () {
    console.log('mounted:Account')
  },

  /** created **/
  created () {
    this.loadAccountList()
  },

  /** watch **/
  watch: {},

  /** destroyed **/
  destroyed () {
    this.reset_state_account()
    this.reset_obj_user_types()
    this.reset_obj_positions()
    this.reset_obj_account
    ()
  }
}
</script>

<style scoped>

input[type=checkbox] {
  transform: scale(2);
}

</style>
